/**
 * jv.candidate.details.workflow.messager.controller Module
 *
 * Description
 */
angular.module('jv.candidate.details.workflow.messager.controller', [])
    .controller('jvCandidateDetailsWorkflowMessagerController',
        ['$scope', '$routeParams', 'candidates', '$location', '$compile', '$rootScope', '$filter', 'jvTotango', '$window', 'jvHireUrlService', CandDetailsWorkflowMessager]);

function CandDetailsWorkflowMessager($scope, $routeParams, candidates, $location, $compile, $rootScope, $filter, jvTotango, $window, jvHireUrlService) {
    // checkMode(parent controller) redirects to workflow tab if there is no mode present.
    angular.extend($scope, $rootScope.parentScope);
    if (!$scope.checkMode()) {
        return;
    }
    $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
    $scope.toggle = {
        panel: true,
        notify: false,
        cc: true,
        bcc: false,
        evaluations: false,
        deadline: false,
        cancel: true
    };

    // Use this instead of $scope.toggle.locations = true
    $scope.interviewers = [];
    $scope.sendToAll = false;
    $scope.employeeSelect = candidates.employeeSelect;
    $scope.interviewersSelect = candidates.interviewersSelect;
    $scope.addInterviewer = function () {
        $scope.interviewers.push($scope.newInterviewer);
    };
    $scope.templateParams = {};
    $scope.templateParams.interviewTypeId = $routeParams.stateId;
    $scope.templateParams.applicationId = $routeParams.applicationId;
    $scope.templateParams.groupId = $routeParams.groupId;
    $scope.interviewTable = {};

    $scope.interviewSchedule = {};
    $scope.result = {};
    $scope.msgTemplate = {};
    $scope.attachments = {};
    $scope.flags.loading = true;
    $scope.toRequired = false;
    $scope.showMeetingRoomInvites = true;

    $scope.edit = {
        SCHEDULE: false,
        CANCEL: false,
        RESCHEDULE: false
    };

    $scope.candidate = {
        firstName: '',
        lastName: '',
        email: ''
    };

    $scope.defaultAttachments = {
        INVITE: {},
        SCHEDULE: {},
        CANCEL: {},
        RESCHEDULE: {},
        DEADLINE: {},
        NOSCHEDULE: {}
    };

    $scope.fileCheck = {
        INVITE: {},
        SCHEDULE: {},
        CANCEL: {},
        RESCHEDULE: {},
        DEADLINE: {},
        NOSCHEDULE: {},
        NOTIFY: {},
        MODIFY_MESSAGE: {}
    };

    $scope.videoConferencingProperties = {
        videoConferenceEnabled: false,
        includeConferenceLink: false,
        includeConferenceLinkViaCSS: false
    };

    $scope.showHide = function (showMeetingRoomInvites) {
        //show or hide meeting room invites section
        if (showMeetingRoomInvites) {
            $scope.isVisibleMeetingRoomInvite = true;
        } else {
            $scope.isVisibleMeetingRoomInvite = false;
        }
    };

    $scope.scheduledInterviewCancelTemplateExpanded = true;
    $scope.candidateInterviewCancelTemplateExpanded = false;
    $scope.sendCancellationNotification = true;

    var tz = window._jvselfUser.locale.timezone;
    if ($scope.selectedTimezoneObj) {
        tz = $scope.selectedTimezoneObj.openSysId;
        $scope.selectedTimezoneObj.timezone = $scope.selectedTimezoneObj.openSysId;
    }
    $scope.tz = tz;

    //disable flag for send button on schedule interview. This is set to true to prevent double clicks
    $scope.disableSchedule = false;
    var action;
    action = ($scope.$parent.mode === 'modifySchedule' || $scope.$parent.mode === 'modifyMessage') ? 'schedule' : $scope.$parent.mode;
    if ($scope.schedules.CANCEL && !$scope.schedules.SCHEDULE && $scope.$parent.mode === 'modifySchedule' && action !== 'schedule') {
        action = 'cancel';
    }

    var updatePostData = function (selectedInterviewers, scheduleUtc) {
        var interviewersFormatted = [],
            timestamp,
            originalUserEId;

        angular.forEach(selectedInterviewers, function (selInterviewer) {
            timestamp = '';
            originalUserEId = selInterviewer.userEId.split('+')[0];
            timestamp += originalUserEId + '+';
            timestamp = $filter('localeDateTime')(scheduleUtc, 'longTimestamp', 'MMMM dd, yyyy HH:mm:ss');
            timestamp += new Date(scheduleUtc).getTime();

            if (timestamp === selInterviewer.userEId) {
                interviewersFormatted.push({
                    userEId: originalUserEId,
                    interviewEId: selInterviewer.interviewEId
                });
            }
        });
        return interviewersFormatted;
    };

    var isModifyMessageFlow = function () {
        return !$.isEmptyObject($scope.updatedInterviewerList) && ($scope.mode === 'modifyMessage' || ($scope.mode === 'modifySchedule' && $scope.modifyOnlyMessage));
    };

    var processPostData = function (postData) {
        $scope.data = angular.copy(postData);
        $scope.data = angular.toJson($scope.data);
        $scope.data = $scope.data.replace(new RegExp('<\\$\\$hashKey>[0-9A-z]+</\\$\\$hashKey>', 'g'), '');
        $scope.data = angular.fromJson($scope.data);

        if ($scope.sendToAll && $scope.mode === 'modifySchedule' && $scope.interviewStatus === 'Schedule' && $scope.schedules['ORIGINAL']) {

            for (var x = 0; x < $scope.schedules['ORIGINAL'].schedules.length; x++) {
                var orgSchedule = $scope.schedules['ORIGINAL'].schedules[x];
                $scope.schedules['ORIGINAL'].schedules[x].fromDate = $rootScope.normalizeDates(orgSchedule.fromDate);
                $scope.schedules['ORIGINAL'].schedules[x].toDate = $rootScope.normalizeDates(orgSchedule.toDate);
            }

            $scope.data['NOTIFY'] = {
                forward: true,
                includePrevious: true,
                schedules: angular.copy($scope.schedules['ORIGINAL'].schedules),
                messageDataItem: {
                    content: $scope.interviewSchedule.data.rescheduleMessage.content,
                    subject: $scope.interviewSchedule.data.rescheduleMessage.subject,
                    attachments: [],
                    defaultAttachments: []
                }
            };
            $scope.sendToAll = false;
        }

        for (var i in $scope.data) {
            /*
             * VALIDATING
             */
            if (!$scope.data[i].messageDataItem.subject || ($scope.data[i].messageDataItem.subject && $scope.data[i].messageDataItem.subject.length > 150)) {
                return false;
            }

            /*
             * REMOVING EMPTY ONES
             */
            if ($scope.data[i].schedules.length === 0) {
                delete $scope.data[i];
                continue;
            }

            /*
             * ADDIDNG BCC
             */
            $scope.data[i].messageDataItem.bcc = [];
            $scope.data[i].messageDataItem.addedFwdRecipents = [];
            $scope.data[i].messageDataItem.removedFwdRecipents = [];
            $scope.data[i].messageDataItem.retainedFwdRecipents = [];
            $scope.finalListFwdRecipents = [];
            $scope.data[i].messageDataItem.sendForwardInvite = $scope.flag.sendForwardInvite;
            for (var j in $scope.postData.cc) {
                $scope.data[i].messageDataItem.bcc.push({
                    eid: $scope.postData.cc[j].EId
                });
                $scope.finalListFwdRecipents.push($scope.postData.cc[j].EId);
                if ($scope.originalListofFwdRecipients && $scope.originalListofFwdRecipients.length > 0) {
                    if ($scope.originalListofFwdRecipients.indexOf($scope.postData.cc[j].EId) > -1) {
                        $scope.data[i].messageDataItem.retainedFwdRecipents.push({
                            eid: $scope.postData.cc[j].EId
                        });
                    } else {
                        $scope.data[i].messageDataItem.addedFwdRecipents.push({
                            eid: $scope.postData.cc[j].EId
                        });
                    }
                } else {
                    $scope.data[i].messageDataItem.addedFwdRecipents.push({
                        eid: $scope.postData.cc[j].EId
                    });
                }
            }

            if ($scope.originalListofFwdRecipients && $scope.originalListofFwdRecipients.length > 0) {
                for (var y in $scope.originalListofFwdRecipients) {
                    if ($scope.finalListFwdRecipents && $scope.finalListFwdRecipents.length > 0) {
                        if ($scope.finalListFwdRecipents.indexOf($scope.originalListofFwdRecipients[y]) < 0) {
                            $scope.data[i].messageDataItem.removedFwdRecipents.push({
                                eid: $scope.originalListofFwdRecipients[y]
                            });
                        }
                    } else {
                        $scope.data[i].messageDataItem.removedFwdRecipents.push({
                            eid: $scope.originalListofFwdRecipients[y]
                        });
                    }
                }
            }


            /*
             * ADDING ATTACHMENTS UPLOADED
             */
            $scope.data[i].messageDataItem.attachments = [];
            for (var l in $scope.data[i].messageDataItem.attach) {
                $scope.data[i].messageDataItem.attachments.push({
                    eid: l
                });
            }

            /*
             * ADDING DEFAULT ATTACHMENTS
             */
            for (var m in $scope.fileCheck[i]) {
                if ($scope.fileCheck[i][m]) {
                    $scope.data[i].messageDataItem.attachments.push({
                        eid: m
                    });
                }
            }

            if ($scope.isVisibleMeetingRoomInvite === false && $scope.$parent.mode !== 'modifySchedule') {
                $scope.data[i].meetingRoomInvites = {
                    subject: $scope.roomSubject
                };
            }

            if ($scope.$parent.mode === 'modifySchedule' && angular.isDefined($scope.roomSubject)) {
                $scope.data[i].meetingRoomInvites = {
                    subject: $scope.roomSubject
                };
            }

            delete $scope.data[i].messageDataItem.attach;
            delete $scope.data[i].messageDataItem.defaultAttachments;

            /*
             * REMOVE GARBAGE DATA FROM SCHEDULES
             */
            for (var k in $scope.data[i].schedules) {
                delete $scope.data[i].schedules[k].interviewers_name;
                delete $scope.data[i].schedules[k].locationName;

                if ($scope.data[i].schedules[k].locationEId && $scope.data[i].schedules[k].locationEId.indexOf('loc-') > -1) {
                    $scope.data[i].schedules[k].locationEId = $scope.data[i].schedules[k].locationEId.split('loc-')[1]; //Ids for Free busy of Resources are reverted to its original Ids to save in database
                }
                if (isModifyMessageFlow()) {
                    if (!$scope.data[i].schedules[k].interviewers.length) {
                        $scope.data[i].schedules[k].interviewers = updatePostData($scope.updatedInterviewerList, $scope.data[i].schedules[k].fromDate);
                    }

                }
            }
        }
        return true;
    };
    var reInitiateScheduleObj = function (scheduleObj, type) {
        var interviewSchedule = angular.copy($scope.interviewSchedule);
        scheduleObj = {
            schedules: [],
            messageDataItem: {

            },
            includePrevious: interviewSchedule.data.sendPreviousEvaluations,
            forward: interviewSchedule.data.sendEvaluationToAll
        };

        if (type === 'SCHEDULE') {
            scheduleObj.messageDataItem = {
                content: interviewSchedule.data.scheduleInterviewMessage.content,
                subject: interviewSchedule.data.scheduleInterviewMessage.subject,
                attachments: [],
                defaultAttachments: []
            };
            for (var i = 0; i < interviewSchedule.data.scheduleInterviewMessage.attachments.length; i++) {
                scheduleObj.messageDataItem.defaultAttachments.push({
                    EId: interviewSchedule.data.scheduleInterviewMessage.attachments[i].EId,
                    fileName: interviewSchedule.data.scheduleInterviewMessage.attachments[i].fileName
                });
                $scope.fileCheck['SCHEDULE'][interviewSchedule.data.scheduleInterviewMessage.attachments[i].EId] = true;
            }
            $scope.postData.schedule[type] = scheduleObj;

        } else if (type === 'RESCHEDULE') {
            scheduleObj.messageDataItem = {
                content: interviewSchedule.data.rescheduleMessage.content,
                subject: interviewSchedule.data.rescheduleMessage.subject,
                attachments: [],
                defaultAttachments: []
            };

            for (var j = 0; j < interviewSchedule.data.rescheduleMessage.attachments.length; j++) {
                scheduleObj.messageDataItem.defaultAttachments.push({
                    EId: interviewSchedule.data.rescheduleMessage.attachments[j].EId,
                    fileName: interviewSchedule.data.rescheduleMessage.attachments[j].fileName
                });
                $scope.fileCheck['RESCHEDULE'][interviewSchedule.data.rescheduleMessage.attachments[j].EId] = true;
            }
            $scope.postData.schedule[type] = scheduleObj;
        } else if (type === 'CANCEL') {
            scheduleObj.messageDataItem = {
                content: interviewSchedule.data.scheduledInterviewCancelTemplate.body,
                subject: interviewSchedule.data.scheduledInterviewCancelTemplate.subject
            };
            $scope.postData.schedule[type] = scheduleObj;
        }
    };

    $scope.removeSchedule = function (type, event, index) {
        if (type === 'CANCEL') {
            if (event.fromDate_original) {
                var data = {};
                if (event.fromDate_original) {
                    data.fromDate = $rootScope.normalizeDates(event.fromDate_original);
                }
                data.interviewers = [];
                data.interviewers_name = [];
                for (var i = 0; i < event.to_obj.length; i++) {
                    data.interviewers.push({
                        userEId: event.to_obj[i].EId,
                        interviewEId: event.to_map[event.to_obj[i].EId].interviewEId || ''
                    });

                    data.interviewers_name.push(event.to_obj[i].firstName + ' ' + event.to_obj[i].lastName);
                }
                if (!$scope.postData.schedule['CANCEL']) {
                    $scope.postData.schedule['CANCEL'] = {};
                    reInitiateScheduleObj($scope.postData.schedule['CANCEL'], 'CANCEL');
                }
                $scope.postData.schedule['CANCEL'].schedules.push(angular.copy(data));
                $scope.ismodifyModal = true;
            }
            if (index > -1) {
                $scope.result.noLocations.splice(index, 1);
            }
        }
    };

    $scope.back = function () {
        $scope.toggle.next = false;
    };

    $scope.backToScheduler = function () {
        $scope.$parent.reRenderEvents = true;
        jvHireUrlService.loadCandidateDetailsTabByLink('/workflow-scheduler/{0}/{1}'.format($scope.params.applicationId, $scope.params.stateId));
    };

    var validateForm = function () {
        var validate = true;
        if ($scope.interviewStatus === 'Deadline') {
            var obj = $scope.result.noLocations;
            for (var i = 0; i < obj.length; i++) {
                if (!obj[i].to || obj[i].to.length < 1) {
                    obj[i].to_error = true;
                    validate = false;
                } else if (obj[i].to.length === 1) {
                    if (!obj[i].to[0]) {
                        obj[i].to_error = true;
                        validate = false;
                    } else if (obj[i].to[0].length === 0) {
                        obj[i].to_error = true;
                        validate = false;
                    }
                }

                if (!obj[i].toTime) {
                    obj[i].toTime_error = true;
                    validate = false;
                }

                if (!obj[i].fromDate) {
                    obj[i].toTime_error = true;
                    validate = false;
                }
            }
        }
        return validate;
    };

    var getDateInMilliSeconds = function (data) {
        //Extract year,month,day
        var temp,
            millisecond,
            year,
            month,
            day;
        year = data.fromDate.getFullYear();
        //getMonth returns (0-11)
        month = data.fromDate.getMonth();
        day = data.fromDate.getDate();

        temp = new Date(year, month, day);
        //Converts to milli seconds
        millisecond = temp.getTime();
        millisecond += data.toTime.h * 60 * 60 * 1000;
        millisecond += data.toTime.m * 60 * 1000;

        return millisecond;
    };

    var fillPostData = function (newData) {
        var isDateModified = false,
            noChangeInData = [],
            interviewUnModified;
        if ($scope.postData.schedule['SCHEDULE']) {
            $scope.postData.schedule['SCHEDULE'].schedules = [];
        }

        if ($scope.postData.schedule['RESCHEDULE']) {
            $scope.postData.schedule['RESCHEDULE'].schedules = [];
        }
        if ($scope.postData.schedule['CANCEL'] && $scope.postData.schedule['CANCEL'].schedules.length > 0) {
            // this scenario occurs when deleting Interviews from html control
            isDateModified = true;
        }
        var data = {};
        for (var k = 0; k < newData.length; k++) {
            if (newData[k].fromDate_original) {
                /*
                 * EXISTING INTERVIEW
                 */
                interviewUnModified = {
                    fromDate: '',
                    interviewers: [],
                    interviewers_name: []
                };
                newData[k].fromDate = new Date(newData[k].fromDate);
                data.fromDate = interviewUnModified.fromDate = $rootScope.normalizeDates(getDateInMilliSeconds(newData[k]));
                for (var x = 0; x < newData[k].to_obj.length; x++) {
                    if (newData[k].to_obj[x].present) {
                        delete newData[k].to_obj[x].present;
                    }
                }

                for (var y = 0; y < newData[k].to.length; y++) {
                    for (var j = 0; j < newData[k].to_obj.length; j++) {
                        if (newData[k].to[y].EId === newData[k].to_obj[j].EId) {
                            newData[k].to_obj[j].present = true;
                            newData[k].to[y].present = true;
                        }
                    }
                }

                if (newData[k].fromDate === newData[k].fromDate_original && newData[k].toTime.h === newData[k].fromDate_original.getHours().toString() && newData[k].toTime.m === newData[k].fromDate_original.getMinutes().toString()) {
                    /*
                     * TIME NOT CHANGED
                     */
                    data.interviewers = [];
                    data.interviewers_name = [];
                    for (var i = 0; i < newData[k].to.length; i++) {
                        if (!newData[k].to_map[newData[k].to[i].EId]) {
                            data.interviewers.push({
                                userEId: newData[k].to[i].EId,
                                interviewEId: newData[k].to_map[newData[k].to[i].EId] ? newData[k].to_map[newData[k].to[i].EId].interviewEId || '' : ''
                            });

                            data.interviewers_name.push(newData[k].to[i].firstName + ' ' + newData[k].to[i].lastName);
                        } else {
                            interviewUnModified.interviewers.push({
                                userEId: newData[k].to[i].EId,
                                interviewEId: newData[k].to_map[newData[k].to[i].EId] ? newData[k].to_map[newData[k].to[i].EId].interviewEId || '' : ''
                            });
                            interviewUnModified.interviewers_name.push(newData[k].to[i].firstName + ' ' + newData[k].to[i].lastName);
                        }
                        if (!newData[k].to[i].present || !newData[k].to_map[newData[k].to[i].EId]) {
                            isDateModified = true;
                        }
                    }
                    if (data.interviewers.length > 0) {
                        if (!$scope.postData.schedule['SCHEDULE']) {
                            $scope.postData.schedule['SCHEDULE'] = {};
                            reInitiateScheduleObj($scope.postData.schedule['SCHEDULE'], 'SCHEDULE');
                        }
                        $scope.postData.schedule['SCHEDULE'].schedules.push(angular.copy(data));
                    }
                } else {
                    /*
                     * TIME CHANGED : MODIFIED
                     */
                    /*
                     * ADD NEW INTERVIEWERS
                     */
                    data.interviewers = [];
                    data.interviewers_name = [];
                    for (var a = 0; a < newData[k].to.length; a++) {
                        if (!newData[k].to[a].present) {
                            data.interviewers.push({
                                userEId: newData[k].to[a].EId,
                                interviewEId: newData[k].to_map[newData[k].to[a].EId] ? newData[k].to_map[newData[k].to[a].EId].interviewEId || '' : ''
                            });
                            data.interviewers_name.push(newData[k].to[a].firstName + ' ' + newData[k].to[a].lastName);
                        }
                    }
                    if (data.interviewers.length > 0) {
                        if (!$scope.postData.schedule['SCHEDULE']) {
                            $scope.postData.schedule['SCHEDULE'] = {};
                            reInitiateScheduleObj($scope.postData.schedule['SCHEDULE'], 'SCHEDULE');
                        }
                        $scope.postData.schedule['SCHEDULE'].schedules.push(angular.copy(data));
                        isDateModified = true;
                    }

                    /*
                     * ADD CURRENT IN MODIFIED
                     */
                    data.interviewers = [];
                    data.interviewers_name = [];
                    for (var z = 0; z < newData[k].to.length; z++) {
                        if (newData[k].to[z].present) {
                            data.interviewers.push({
                                userEId: newData[k].to[z].EId,
                                interviewEId: newData[k].to_map[newData[k].to[z].EId] ? newData[k].to_map[newData[k].to[z].EId].interviewEId || '' : ''
                            });
                            data.interviewers_name.push(newData[k].to[z].firstName + ' ' + newData[k].to[z].lastName);
                        }
                    }
                    if (data.interviewers.length > 0) {
                        if (!$scope.postData.schedule['RESCHEDULE']) {
                            $scope.postData.schedule['RESCHEDULE'] = {};
                            reInitiateScheduleObj($scope.postData.schedule['RESCHEDULE'], 'RESCHEDULE');
                        }
                        $scope.postData.schedule['RESCHEDULE'].schedules.push(angular.copy(data));
                        isDateModified = true;
                    }
                }

                data.interviewers = [];
                data.interviewers_name = [];
                for (var l = 0; l < newData[k].to_obj.length; l++) {
                    if (!newData[k].to_obj[l].present) {
                        data.interviewers.push({
                            userEId: newData[k].to_obj[l].EId,
                            interviewEId: newData[k].to_map[newData[k].to_obj[l].EId] ? newData[k].to_map[newData[k].to_obj[l].EId].interviewEId || '' : ''
                        });

                        data.interviewers_name.push(newData[k].to_obj[l].firstName + ' ' + newData[k].to_obj[l].lastName);
                    }
                }
                if (data.interviewers.length > 0) {
                    if (!$scope.postData.schedule['CANCEL']) {
                        $scope.postData.schedule['CANCEL'] = {};
                        reInitiateScheduleObj($scope.postData.schedule['CANCEL'], 'CANCEL');
                    }
                    $scope.postData.schedule['CANCEL'].schedules.push(angular.copy(data));
                    isDateModified = true;
                }
                noChangeInData.push(interviewUnModified);

            } else {
                /*
                 * NEW INTERVIEW
                 */
                newData[k].fromDate = new Date(newData[k].fromDate);
                data.fromDate = $rootScope.normalizeDates(newData[k].fromDate.getTime() + (newData[k].toTime.h * 60 * 60 * 1000) + (newData[k].toTime.m * 60 * 1000));
                data.interviewers = [];
                data.interviewers_name = [];
                for (var m = 0; m < newData[k].to.length; m++) {
                    data.interviewers.push({
                        userEId: newData[k].to[m].EId
                    });

                    data.interviewers_name.push(newData[k].to[m].firstName + ' ' + newData[k].to[m].lastName);
                }
                if (data.interviewers.length > 0) {
                    if (!$scope.postData.schedule['SCHEDULE']) {
                        $scope.postData.schedule['SCHEDULE'] = {};
                        reInitiateScheduleObj($scope.postData.schedule['SCHEDULE'], 'SCHEDULE');
                    }
                    $scope.postData.schedule['SCHEDULE'].schedules.push(angular.copy(data));
                    isDateModified = true;
                }
            }
        }
        if (!$.isEmptyObject(noChangeInData) && !isDateModified && !$.isEmptyObject($scope.postData)) {
            if (!$scope.postData.schedule['RESCHEDULE'] || ($scope.postData.schedule['RESCHEDULE'] && $scope.postData.schedule['RESCHEDULE'].schedules.length === 0)) {
                $scope.postData.schedule['RESCHEDULE'] = {};
                reInitiateScheduleObj($scope.postData.schedule['RESCHEDULE'], 'RESCHEDULE');
            }
            $scope.postData.schedule['RESCHEDULE'].schedules = angular.copy(noChangeInData);
        }
        if ($scope.postData.schedule['SCHEDULE'] && $scope.postData.schedule['SCHEDULE'].schedules.length === 0) {
            delete $scope.postData.schedule['SCHEDULE'];
        }

        if ($scope.postData.schedule['RESCHEDULE'] && $scope.postData.schedule['RESCHEDULE'].schedules.length === 0) {
            delete $scope.postData.schedule['RESCHEDULE'];
        }

        if ($scope.postData.schedule['CANCEL'] && (!$scope.postData.schedule['CANCEL'].schedules || ($scope.postData.schedule['CANCEL'].schedules && $scope.postData.schedule['CANCEL'].schedules.length === 0))) {
            delete $scope.postData.schedule['CANCEL'];
        }
        if (!isDateModified && !$scope.ismodifyModal) {
            $scope.modifyModal.show = true;
            $scope.$root.modal = $scope.modifyModal;
            $scope.ismodifyModal = true;
            return false;
        }
        return true;
    };

    var convertInterviewersObj = function (events) {
        for (var i = 0; i < events.length; i++) {
            var eIds = [];
            for (var j = 0; j < events[i].to.length; j++) {
                eIds.push(events[i].to[j].EId);
            }
            events[i].to_obj = angular.copy(events[i].to);
            events[i].to = eIds;
        }
    };

    var processInterviewByTime = function (schedule) {
        var val = angular.copy(schedule);
        val.fromDate = new Date(val.fromDate);
        var date;

        if (val.start) {
            date = val.start;
        } else if (val.fromDate) {
            date = val.fromDate;
        }
        $scope.interviewTable[date] = $scope.interviewTable[date] || [];
        var interview = {
            end: val.end || '',
            user: []
        };

        if (val.start) {
            interview.start = val.start;
        } else if (val.fromDate) {
            var tempDate = new Date(val.fromDate.getYear() + 1900, val.fromDate.getMonth(), val.fromDate.getDate());
            interview.start = tempDate.getTime() + (val.toTime.h * 60 * 60 * 1000) + (val.toTime.m * 60 * 1000);
        }

        if ($scope.allLocations && $scope.allLocations[val.location]) {
            interview.location = $scope.allLocations[val.location].name;
            $scope.meetingRoomLocation = interview.location;
        }

        if (angular.isUndefined($scope.meetingRoomLocation)) {
            $scope.meetingRoomLocation = false;
        }

        if (val.interviewers) {
            angular.forEach(val.interviewers, function (interviewer) {
                interview.user.push({
                    name: interviewer.firstName + ' ' + interviewer.lastName,
                    title: interviewer.email
                });
            });
        } else if (val.to_obj) {
            angular.forEach(val.to_obj, function (interviewer) {
                interview.user.push({
                    name: interviewer.firstName + ' ' + interviewer.lastName,
                    title: interviewer.email
                });
            });
        }
        $scope.interviewTable[date].push(interview);
    };

    $scope.next = function () {
        var validate = validateForm();
        $scope.$parent.modifyOnlyMessage = arguments[0];
        if (!validate) {
            return;
        }
        var iscontinue = fillPostData($scope.result.noLocations);
        if (iscontinue) {
            if (iscontinue || ($scope.postData.schedule['SCHEDULE'] && $scope.postData.schedule['SCHEDULE'].schedules.length > 0) || ($scope.postData.schedule['RESCHEDULE'] && $scope.postData.schedule['RESCHEDULE'].schedules.length > 0) || ($scope.postData.schedule['CANCEL'] && $scope.postData.schedule['CANCEL'].schedules && $scope.postData.schedule['CANCEL'].schedules.length > 0)) {
                convertInterviewersObj($scope.result.noLocations);
                $scope.interviewTable = {};
                for (var i in $scope.result.noLocations) {
                    processInterviewByTime($scope.result.noLocations[i]);
                }

                $scope.toggle.next = true;
            } else {
                $scope.showMsg('NO_CHANGES_DETECTED');
            }
        }
    };

    var initiateInterviewSchedule = function (interviewSchedule) {
        $scope.postData = {
            schedule: {
                'SCHEDULE': {
                    schedules: [],
                    messageDataItem: {

                    },
                    includePrevious: interviewSchedule.data.sendPreviousEvaluations,
                    forward: interviewSchedule.data.sendEvaluationToAll
                },
                'RESCHEDULE': {
                    schedules: [],
                    messageDataItem: {

                    },
                    includePrevious: interviewSchedule.data.sendPreviousEvaluations,
                    forward: interviewSchedule.data.sendEvaluationToAll
                },
                'CANCEL': {
                    schedules: [],
                    messageDataItem: {

                    },
                    includePrevious: interviewSchedule.data.sendPreviousEvaluations,
                    forward: interviewSchedule.data.sendEvaluationToAll
                }
            }
        };
        $scope.allowCustomMeetingRoomSection = interviewSchedule.data.isRescheduleInterview;
        $scope.isMessageRoomInvites = interviewSchedule.data.meetingRoomInvites;

        if (angular.isDefined($scope.isMessageRoomInvites)) {
            $scope.meetingRoomSubject = interviewSchedule.data.meetingRoomInvites.subject;
            $scope.roomSubject = interviewSchedule.data.meetingRoomInvites.subject;
        }
        if (angular.isUndefined($scope.isMessageRoomInvites)) {
            $scope.isCustomSection = true;
            $scope.allowCustomMeetingRoomSection = false;
        }
        if ($scope.interviewStatus === 'Deadline') {
            $scope.deadLineInterview = true;
        }
        $scope.meetingRoomPlaceholder = function (meetingRoomSubject) {
            $scope.roomSubject = meetingRoomSubject;
        };

        if (interviewSchedule && interviewSchedule.data && interviewSchedule.data.forwardRecipients && interviewSchedule.data.forwardRecipients.length) {
            $scope.postData.cc = interviewSchedule.data.forwardRecipients.join(',');
            $scope.originalListofFwdRecipients = interviewSchedule.data.forwardRecipients;
            $scope.disableSendInviteCheckbox = true;
        }

        if (interviewSchedule.data.scheduleInterviewMessage) {
            $scope.postData.schedule['SCHEDULE'].messageDataItem = {
                content: interviewSchedule.data.scheduleInterviewMessage.content,
                subject: interviewSchedule.data.scheduleInterviewMessage.subject,
                attachments: [],
                defaultAttachments: []
            };

            for (var i = 0; i < interviewSchedule.data.scheduleInterviewMessage.attachments.length; i++) {
                $scope.postData.schedule['SCHEDULE'].messageDataItem.defaultAttachments.push({
                    EId: interviewSchedule.data.scheduleInterviewMessage.attachments[i].EId,
                    fileName: interviewSchedule.data.scheduleInterviewMessage.attachments[i].fileName
                });
                $scope.fileCheck['SCHEDULE'][interviewSchedule.data.scheduleInterviewMessage.attachments[i].EId] = true;
            }
        } else {
            delete $scope.postData.schedule['SCHEDULE'];
        }

        if (interviewSchedule.data.rescheduleMessage) {
            $scope.postData.schedule['RESCHEDULE'].messageDataItem = {
                content: interviewSchedule.data.rescheduleMessage.content,
                subject: interviewSchedule.data.rescheduleMessage.subject,
                attachments: [],
                defaultAttachments: []
            };
            for (var j = 0; j < interviewSchedule.data.rescheduleMessage.attachments.length; j++) {
                $scope.postData.schedule['RESCHEDULE'].messageDataItem.defaultAttachments.push({
                    EId: interviewSchedule.data.rescheduleMessage.attachments[j].EId,
                    fileName: interviewSchedule.data.rescheduleMessage.attachments[j].fileName
                });
                $scope.fileCheck['RESCHEDULE'][interviewSchedule.data.rescheduleMessage.attachments[j].EId] = true;
            }
        } else {
            delete $scope.postData.schedule['RESCHEDULE'];
        }

        if (interviewSchedule.data.scheduledInterviewCancelTemplate) {
            $scope.postData.schedule['CANCEL'].messageDataItem = {
                content: interviewSchedule.data.scheduledInterviewCancelTemplate.body,
                subject: interviewSchedule.data.scheduledInterviewCancelTemplate.subject
            };
        } else {
            delete $scope.postData.schedule['CANCEL'];
        }
    };

    if ($rootScope.fastReadOn) {
        $scope.templateParams.readMode = true;
    }

    var getInterviewers = function (interview) {
        var interviewers = $filter('orderBy')(interview.interviewers, 'firstName');
        var temp = {
            interviewers: [],
            interviewerFullObj: {},
            interviewersEId: []
        };
        // Looping through the interviewers
        angular.forEach(interviewers, function (interviewer) {
            temp.interviewers.push({
                userEId: interviewer.userEId,
                interviewEId: interviewer.interviewEId
            });
            // This object construction is used in scheduleSummary object.
            temp.interviewerFullObj[interviewer.email] = {
                EId: interviewer.userEId,
                firstName: interviewer.firstName,
                lastName: interviewer.lastName,
                fullName: interviewer.firstName + ' ' + interviewer.lastName,
                email: interviewer.email,
                interviewEId: interviewer.interviewEId || ''
            };
            temp.interviewersEId.push(interviewer.userEId);

        });
        return temp;
    };

    // Constructing post data for 'modify message' flow
    var constructPostData = function (interviewSchedule) {
        var schedule = {
                MODIFY_MESSAGE: {
                    schedules: [],
                    messageDataItem: {
                        content: interviewSchedule.rescheduleMessage.content,
                        subject: interviewSchedule.rescheduleMessage.subject,
                        attachments: [],
                        defaultAttachments: [],
                        attach: {}
                    },
                    forward: interviewSchedule.sendEvaluationToAll,
                    fileCheck: {}
                }

            },
            scheduleSummary = [],
            toDate,
            tmp,
            date,
            interviewerMoreInfo;

        angular.forEach(interviewSchedule.durationInfo, function (interview, index) {
            //Get interviewers in certain format to post
            interviewerMoreInfo = getInterviewers(interview);
            //Modify message flow
            //date = new Date(moment.tz(interview.scheduleUtc,_jvselfUser.locale.timezone).format('YYYY-MM-DDTHH:mm:ss'));
            date = moment(moment.tz(interview.scheduleUtc, tz).format('YYYY-MM-DDTHH:mm:ss'));
            date = date.toDate();
            if (interview.duration) {
                var durationInMill = interview.duration * 60 * 1000;
                toDate = interview.scheduleUtc + durationInMill;
                //toDate = new Date(toDate);
            }
            tmp = {};
            tmp.fromDate = moment.tz(interview.scheduleUtc, tz).format('MMMM DD, YYYY HH:mm:ss');
            tmp.interviewers = interviewerMoreInfo.interviewers;

            if ($scope.videoConferencingProperties.videoConferenceEnabled) {
                tmp.meetingId = interview.meetingId;
                tmp.host = interview.hostEId;
                tmp.useVC = interview.useVC;
            }

            if (toDate) {
                tmp.toDate = moment.tz(toDate, tz).format('MMMM DD, YYYY HH:mm:ss');
            }
            if (interview.locationEId) {
                tmp.locationEId = interview.locationEId;
            }
            if (interview.locationName) {
                tmp.locationName = interview.locationName;
            }

            // Custom Local Names
            if (interview.location) {
                tmp.locationEId = '_' + index;
                tmp.otherLocation = interview.location;
                tmp.locationName = interview.location;
            }

            schedule['MODIFY_MESSAGE']['schedules'].push(tmp);

            var summaryObject = {
                to_obj: interviewerMoreInfo.interviewerFullObj,
                to: interviewerMoreInfo.interviewersEId,
                fromDate: date,
                fromDate_original: date,
                toTime: {
                    h: date.getHours(),
                    m: date.getMinutes()
                },
                location: (interview.locationEId) ? 'loc-' + interview.locationEId : ''
            };
            //for deadline type interview there is no toDate
            if (tmp.toDate) {
                summaryObject.end = moment(moment.tz(toDate, tz).format('YYYY-MM-DDTHH:mm:ss')).toDate();
            }
            // Constructing a summary object which is used to show location and interview information under interview schedule
            scheduleSummary.push(summaryObject);

        });
        // Looping through the default attachments which are configured at admin and shown while schedule / modify
        angular.forEach(interviewSchedule.rescheduleMessage.attachments, function (attachment) {
            schedule['MODIFY_MESSAGE'].messageDataItem.defaultAttachments.push({
                EId: attachment.EId,
                fileName: attachment.fileName
            });
            // default attachment checkbox set to true/checked.
            schedule['MODIFY_MESSAGE'].fileCheck[attachment.EId] = true;
        });

        //Looping through the schedule summary to create certain format
        angular.forEach(scheduleSummary, function (schedule) {
            processInterviewByTime(schedule);
        });

        return {
            schedule: schedule
        };
    };

    var getLocations = function (locations) {
        var allLocations = {};
        angular.forEach(locations, function (location) {
            allLocations['loc-' + location.EId] = {
                EId: location.EId,
                email: location.email,
                name: location.name
            };
        });
        return allLocations;
    };
    candidates.getTemplate($scope.templateParams, action, function (response, code) {
        var fileEId;
        if (response && code === 200) {
            $scope.flags.loading = false;
            if (response && response.interviewSchedule && response.interviewSchedule.model) {
                $scope.disableForwardRecipientInvites = response.interviewSchedule.model.disableForwardRecipientInvites;
                $scope.flag = {};
                if (response.interviewSchedule.model.sendInvite) {
                    $scope.flag.sendForwardInvite = response.interviewSchedule.model.sendInvite;
                } else {
                    $scope.flag.sendForwardInvite = false;
                }
                if ($scope.interviewStatus === 'Schedule' && $scope.$root.parentScope.videoConferencingProperties) {
                    // modify schedule
                    $scope.videoConferencingProperties.includeConferenceLink = $scope.$root.parentScope.videoConferencingProperties.includeConferenceLink;
                    $scope.videoConferencingProperties.includeConferenceLinkViaCSS = $scope.$root.parentScope.videoConferencingProperties.includeConferenceLinkViaCSS;
                } else {
                    // modify message
                    if(response && response.interviewSchedule && response.interviewSchedule.model && Array.isArray(response.interviewSchedule.model.durationInfo) && response.interviewSchedule.model.durationInfo.length > 0){
                        $scope.videoConferencingProperties.includeConferenceLink = response.interviewSchedule.model.durationInfo[0].useVC;
                    }
                }
                
                $scope.videoConferencingProperties.videoConferenceEnabled = response.interviewSchedule.model.videoConferenceEnabled;
            }
            //Flag to show chekcbox on UI for attaching candidate resume/coverletter
            if (response && response.interviewSchedule && (response.interviewSchedule.model.attachResume || response.interviewSchedule.model.attachCoverLetter)) {
                $scope.showAttachResumeMessage = response.interviewSchedule.model.attachResume;
                $scope.showAttachCoverLetterMessage = response.interviewSchedule.model.attachCoverLetter;
                $scope.candidateResume = [];
                $scope.candidateCoverLetter = [];
                candidates.getCandFiles($routeParams.applicationId, null, function (data) {
                    if (data && data.candidateFiles) {
                        angular.forEach(data.candidateFiles, function (fileObj) {
                            if (fileObj.fileKind === 'Resume' || fileObj.fileKind === 'CoverLetter') {
                                if(fileObj.fileKind === 'Resume') {
                                    $scope.candidateResume.push(fileObj);
                                } else {
                                    $scope.candidateCoverLetter.push(fileObj);
                                }
                                //Making sure candiate resume checkbox is checked by default
                                if ((($scope.mode === 'modifySchedule') || ($scope.mode === 'modifyMessage')) && $scope.interviewStatus === 'Schedule') {
                                    //modify schedule
                                    $scope.fileCheck['RESCHEDULE'][fileObj.EId] = true;
                                    $scope.fileCheck['SCHEDULE'][fileObj.EId] = true;
                                } else {
                                    $scope.fileCheck[$scope.interviewStatus.toUpperCase()][fileObj.EId] = true;
                                }
                                var resource = {
                                    resourceInfo: {
                                        eid: fileObj.EId,
                                        fileName: fileObj.fileName
                                    }
                                };
                                if (!$scope.attachments[$scope.interviewStatus.toUpperCase()]) {
                                    $scope.attachments[$scope.interviewStatus.toUpperCase()] = {};
                                }
                                $scope.attachments[$scope.interviewStatus.toUpperCase()][fileObj.EId] = resource;
                            }
                        });
                    }
                });
            }
            switch (action) {
                case 'invite':
                    $scope.pageTitle = i18n.titles['INVITE'];
                    $scope.toggle.panel = false;
                    $scope.toggle.notify = true;
                    $scope.toggle.cc = false;
                    $scope.toggle.bcc = true;

                    $scope.interviewType = response.inviteCandidate.workflowElementInfo.elementName;
                    $scope.msgTemplate.SCHEDULE = {};
                    $scope.msgTemplate.SCHEDULE.subject = response.inviteCandidate.model.inviteMessage.subject;
                    $scope.msgTemplate.SCHEDULE.content = response.inviteCandidate.model.inviteMessage.content;

                    delete $scope.copiedSchedules;

                    $scope.pageTitle = $scope.format($scope.pageTitle, {
                        type: $scope.interviewType
                    });

                    $scope.msgTemplate.subject = response.inviteCandidate.model.inviteMessage.subject;
                    $scope.msgTemplate.content = response.inviteCandidate.model.inviteMessage.content;

                    if (response.inviteCandidate.model.inviteMessage.to) {
                        $scope.msgTemplate.to = response.inviteCandidate.model.inviteMessage.to;
                    }

                    $scope.result.SCHEDULE = {};
                    $scope.result.SCHEDULE.subject = response.inviteCandidate.model.inviteMessage.subject;
                    $scope.result.SCHEDULE.content = response.inviteCandidate.model.inviteMessage.content;

                    $scope.result.subject = response.inviteCandidate.model.inviteMessage.subject;
                    $scope.result.content = response.inviteCandidate.model.inviteMessage.content;

                    if (response.inviteCandidate.model.inviteMessage.forms) {
                        $scope.result.formIds = [];
                        angular.forEach(response.inviteCandidate.model.inviteMessage.forms, function (value) {
                            $scope.result.formIds.push(value.EId);
                        });
                    }
                    //This controls the show/hide of the notify checkbox
                    $scope.isAgencyCandidate = response.inviteCandidate.model.isAgencyCandidate;
                    $scope.result.isCandidateCopied = false;

                    /**
                        Adding default attachments for Invite Template
                     **/

                    $scope.defaultAttachments['INVITE'] = response.inviteCandidate.model.inviteMessage.attachments;
                    $scope.attachments['INVITE'] = {};

                    /*FileDownload Tokens for default attachments*/
                    $scope.fileDownloadToken = response.inviteCandidate.model.fileDownloadToken;

                    /*setting the checkbox to true for each default attachment*/
                    for (var x = 0; x < $scope.defaultAttachments['INVITE'].length; x++) {
                        fileEId = $scope.defaultAttachments['INVITE'][x].EId;
                        $scope.fileCheck['INVITE'][fileEId] = true;
                        $scope.addDefaultAttachment($scope.defaultAttachments['INVITE'][x], $scope.fileCheck, 'INVITE', x);
                    }


                    break;

                case 'cancel':
                    $scope.data = response.interviewType;
                    var emp = [];
                    $scope.sendCalendarInvite = response.interviewType.model.sendInvite;
                    if ($scope.data.model && $scope.data.model.interviews && $scope.data.model.interviews.length > 0) {
                        for (var q = 0; q < $scope.data.model.interviews.length; q++) {
                            if ($scope.data.model.interviews[q].scheduleUtc) {
                                var d = new Date(angular.copy($scope.data.model.interviews[q].scheduleUtc));
                                $scope.data.model.interviews[q].scheduleUtc = d.getTime();
                                $scope.data.model.interviews[q].schedule = $scope.data.model.interviews[q].scheduleUtc;
                                $scope.data.model.interviews[q].scheduleEndDate = $scope.data.model.interviews[q].scheduleUtc + ($scope.data.model.interviews[q].duration * 60 * 1000);
                            }
                        }
                    }
                    //Adding list of forward Recipient List
                    angular.forEach(response.interviewType.model.forwardRecipientsList, function (employee) {
                        emp.push(employee.firstName + ' ' + employee.lastName);
                    });

                    $scope.fowardScheduleList = emp.join(', ');

                    if (response.interviewType.model.scheduledInterviewCancelTemplate) {
                        $scope.result.CANCEL = {
                            subject: response.interviewType.model.scheduledInterviewCancelTemplate.subject,
                            content: response.interviewType.model.scheduledInterviewCancelTemplate.body,
                            locale: response.interviewType.model.scheduledInterviewCancelTemplate.locale
                        };
                        // Show editor by default?
                        $scope.solo = true;
                    }
                    if (response.interviewType.model.unScheduledInterviewCancelTemplate) {
                        $scope.result.CANCEL_NODATE = {
                            subject: response.interviewType.model.unScheduledInterviewCancelTemplate.subject,
                            content: response.interviewType.model.unScheduledInterviewCancelTemplate.body,
                            locale: response.interviewType.model.unScheduledInterviewCancelTemplate.locale
                        };
                        // Show editor by default?
                        $scope.solo = !$scope.solo;
                    }
                    if (response.interviewType.model.candidateInterviewCancelTemplate) {
                        $scope.result.CANCEL_CANDIDATE_TEMPLATE = {
                            subject: response.interviewType.model.candidateInterviewCancelTemplate.subject,
                            content: response.interviewType.model.candidateInterviewCancelTemplate.body,
                            locale: response.interviewType.model.candidateInterviewCancelTemplate.locale
                        };
                    }
                    if (response.interviewType.model.inviteMessage) {
                        $scope.candidate = {
                            firstName: response.interviewType.model.inviteMessage.to[0].firstName,
                            lastName: response.interviewType.model.inviteMessage.to[0].lastName,
                            email: response.interviewType.model.inviteMessage.to[0].email
                        };
                    }
                    if ($scope.solo) {
                        if ($scope.result.CANCEL) {
                            $scope.result.CANCEL.edit = true;
                        }
                        if ($scope.result.CANCEL_CANDIDATE_TEMPLATE) {
                            $scope.result.CANCEL_CANDIDATE_TEMPLATE.edit = true;
                        }
                        //$scope.result.CANCEL_NODATE.edit = true;
                    }
                    $scope.isScheduled = function (value) {
                        return !!value.schedule && !value.completed && (!value.interviewStatus || value.interviewStatus !== 'Canceled');
                    };
                    $scope.isUnscheduled = function (value) {
                        return !value.schedule && !value.completed && (!value.interviewStatus || value.interviewStatus !== 'Canceled');
                    };

                    $scope.showUnscheduled = false;
                    for (var z = 0; z < $scope.data.model.interviews.length; z++) {
                        var interview = $scope.data.model.interviews[z];
                        if (!interview.schedule && !interview.completed && (!interview.interviewStatus || interview.interviewStatus !== 'Canceled')) {
                            $scope.showUnscheduled = true;
                        }
                    }
                    break;

                case 'schedule':

                    $scope.interviewType = response.interviewSchedule.workflowElementInfo.elementName;
                    $scope.interviewSchedule.data = angular.copy(response.interviewSchedule.model);
                    $scope.fileDownloadToken = response.interviewSchedule.model.fileDownloadToken;

                    if ($scope.interviewStatus !== 'Schedule') {
                        //deadline and no-schedule interview type
                        if ($scope.mode === 'modifySchedule') {
                            $scope.modifyInterviewers = {};
                            $scope.pageTitle = i18n.titles['MODIFY_DEADLINE_FOR_TYPE'];
                            $scope.result.noLocations = [];
                            $scope.toggle.cc = false;
                            $scope.pageTitle = $scope.format($scope.pageTitle, {
                                type: $scope.interviewType
                            });
                            var interviews = angular.copy(response.interviewSchedule.model.durationInfo);
                            for (var i = 0; i < interviews.length; i++) {
                                var interviewers = [];
                                var interviewersEId = [];
                                var interviewersMap = {};
                                for (var j = 0; j < interviews[i].interviewers.length; j++) {
                                    interviewers.push({
                                        EId: interviews[i].interviewers[j].userEId,
                                        firstName: interviews[i].interviewers[j].firstName,
                                        lastName: interviews[i].interviewers[j].lastName,
                                        fullName: interviews[i].interviewers[j].fullName,
                                        email: interviews[i].interviewers[j].email,
                                        interviewEId: interviews[i].interviewers[j].interviewEId || ''
                                    });

                                    interviewersMap[interviews[i].interviewers[j].userEId] = interviewers[interviewers.length - 1];

                                    interviewersEId.push(interviews[i].interviewers[j].userEId);
                                }
                                var date = moment(moment.tz(interviews[i].scheduleUtc, tz).format('YYYY-MM-DDTHH:mm:ss'));
                                date = date.toDate();
                                $scope.result.noLocations.push({
                                    to_obj: interviewers,
                                    to: interviewersEId,
                                    to_map: interviewersMap,
                                    fromDate: date,
                                    fromDate_original: date,
                                    toTime: {
                                        h: date.getHours(),
                                        m: date.getMinutes()
                                    }
                                });
                            }

                            initiateInterviewSchedule($scope.interviewSchedule);
                        } else {
                            if ($scope.mode === 'modifyMessage') {
                                // Constructing the post data
                                $scope.postData = constructPostData($scope.interviewSchedule.data);

                                $scope.fileCheck['RESCHEDULE'] = $scope.postData.schedule.MODIFY_MESSAGE.fileCheck;
                                delete $scope.postData.schedule.MODIFY_MESSAGE.fileCheck;

                                $scope.modifyInterviewers = {};

                            } else {
                                $scope.toggle.cc = true;
                                $scope.pageTitle = $scope.interviewType;

                                if ($scope.interviewSchedule.data.scheduleInterviewMessage) {
                                    $scope.result.subject = $scope.interviewSchedule.data.scheduleInterviewMessage.subject;
                                    $scope.result.content = $scope.interviewSchedule.data.scheduleInterviewMessage.content;
                                }

                                if (!response.interviewSchedule.workflowElementInfo.metaModel.interviewLocation && $scope.interviewStatus === 'Deadline') {
                                    $scope.result.noLocations = [{
                                        toTime: {
                                            h: 17,
                                            m: parseInt('0o00')
                                        }
                                    }];
                                }

                                if ($scope.interviewStatus === 'NoSchedule') {
                                    $scope.result.noSchedule = {};
                                    $scope.pageTitle = $scope.format($scope.pageTitle, {
                                        type: $scope.interviewType
                                    });
                                    $scope.defaultAttachments['NOSCHEDULE'] = response.interviewSchedule.model.scheduleInterviewMessage.attachments;
                                    $scope.attachments['NOSCHEDULE'] = {};

                                    if ($scope.defaultAttachments['NOSCHEDULE'].length > 0) {
                                        for (var m = 0; m < $scope.defaultAttachments['NOSCHEDULE'].length; m++) {
                                            fileEId = $scope.defaultAttachments['NOSCHEDULE'][m].EId;
                                            $scope.fileCheck['NOSCHEDULE'][fileEId] = true;
                                            $scope.addDefaultAttachment($scope.defaultAttachments['NOSCHEDULE'][m], $scope.fileCheck, $scope.interviewStatus, m);
                                        }
                                    }
                                }

                                if ($scope.interviewStatus === 'Deadline') {
                                    $scope.pageTitle = $scope.format(i18n.titles['DEADLINE'], {
                                        type: $scope.interviewType
                                    });
                                    $scope.defaultAttachments['DEADLINE'] = response.interviewSchedule.model.scheduleInterviewMessage.attachments;
                                    $scope.attachments['DEADLINE'] = {};

                                    if ($scope.defaultAttachments['DEADLINE'].length > 0) {
                                        for (var l = 0; l < $scope.defaultAttachments['DEADLINE'].length; l++) {
                                            fileEId = $scope.defaultAttachments['DEADLINE'][l].EId;
                                            $scope.fileCheck['DEADLINE'][fileEId] = true;
                                            $scope.addDefaultAttachment($scope.defaultAttachments['DEADLINE'][l], $scope.fileCheck, $scope.interviewStatus, l);
                                        }
                                    }
                                }
                            }

                        }
                    } else {
                        if ($scope.mode === 'modifyMessage') {
                            if (response.interviewSchedule.model && response.interviewSchedule.model.interviewTimezone) {
                                $scope.selectedTimezoneObj = response.interviewSchedule.model.interviewTimezone;
                                $scope.selectedTimezoneObj.timezone = response.interviewSchedule.model.interviewTimezone.openSysId;
                                tz = $scope.selectedTimezoneObj.openSysId;
                                $scope.tz = tz;
                            }
                            
                            $scope.disableSendInviteCheckbox = true;
                            $scope.allLocations = getLocations(response.interviewSchedule.workflowElementInfo.metaModel.interviewLocation);

                            // Constructing the post data
                            $scope.postData = constructPostData($scope.interviewSchedule.data);

                            $scope.fileCheck['RESCHEDULE'] = $scope.postData.schedule.MODIFY_MESSAGE.fileCheck;
                            delete $scope.postData.schedule.MODIFY_MESSAGE.fileCheck;

                            $scope.modifyInterviewers = {};
                        } else {
                            $scope.edit.SCHEDULE = true;
                            $scope.toggle.cc = false;
                            $scope.pageTitle = i18n.titles['SCHEDULE'];
                            $scope.toggle.panel = true;
                            $scope.modifyInterviewers = {};

                            /*
                             * POST DATA FILL
                             */
                            initiateInterviewSchedule($scope.interviewSchedule);
                            $scope.postData = $scope.postData || {};
                            for (var b in $scope.schedules) {
                                if ($scope.postData.schedule && $scope.postData.schedule[b]) {
                                    $scope.postData.schedule[b].schedules = angular.copy($scope.schedules[b].schedules);
                                    angular.forEach($scope.postData.schedule[b].schedules, function (schedule) { // eslint-disable-line no-loop-func
                                        schedule.interviewers_name = [];
                                        schedule.fromDate = $rootScope.normalizeDates(schedule.fromDate);
                                        schedule.toDate = $rootScope.normalizeDates(schedule.toDate);
                                        angular.forEach(schedule.interviewers, function (user) {
                                            for (var EId in $scope.schedInterviewers[b]) {
                                                if (EId === user.userEId) {
                                                    schedule.interviewers_name.push($scope.schedInterviewers[b][EId].firstName + ' ' + $scope.schedInterviewers[b][EId].lastName);
                                                    break;
                                                }
                                            }
                                        });
                                    });
                                }
                            }

                            for (var n in $scope.scheduledEvents) {
                                if ($scope.scheduledEvents[n].className && $scope.scheduledEvents[n].className.indexOf('static') === -1) {
                                    processInterviewByTime($scope.scheduledEvents[n]);
                                }
                            }

                            for (var p in $scope.postData.schedule) {
                                if (!$scope.postData.schedule[p].schedules || $scope.postData.schedule[p].schedules.length === 0) {
                                    delete $scope.postData.schedule[p];
                                }
                            }

                            $scope.toggle.next = true;
                        }

                    }

                    $scope.result.includePrevious = true;
                    $scope.result.forward = false;
                    break;
                default:
                    break;
            }
        }

    });


    $scope.deleteDefaultAttachments = function (type, index, fileEId) {
        var fileToDelete;
        switch (type) {
            case 'INVITE':
                fileToDelete = $('.attach_INVITE .qq-upload-success' + index);
                break;
            case 'SCHEDULE':
                fileToDelete = $('.attach_SCHEDULE .qq-upload-success' + index);
                break;
            case 'RESCHEDULE':
                fileToDelete = $('.attach_RESCHEDULE .qq-upload-success' + index);
                break;
            case 'NOTIFY':
                fileToDelete = $('.attach_NOTIFY .qq-upload-success' + index);
                break;
            case 'DEADLINE':
                fileToDelete = $('.attach_DEADLINE .qq-upload-success' + index);
                break;
            case 'NOSCHEDULE':
                fileToDelete = $('.attach_NOSCHEDULE .qq-upload-success' + index);
                break;
            default:
                break;
        }
        if ($scope.attachments[type] && $scope.attachments[type][fileEId]) {
            delete $scope.attachments[type][fileEId];
        } else {
            delete $scope.attachments[fileEId];
        }
        $(fileToDelete).remove();
        $scope.fileCheck[type][fileEId] = false;
    };

    $scope.addDefaultAttachment = function (file, fileCheck, type, index) {
        var uploader;
        switch (type) {
            case 'INVITE':
                uploader = $('.attach_INVITE .qq-upload-list');
                break;
            case 'SCHEDULE':
                uploader = $('.attach_SCHEDULE .qq-upload-list');
                break;
            case 'RESCHEDULE':
                uploader = $('.attach_RESCHEDULE .qq-upload-list');
                break;
            case 'NOTIFY':
                uploader = $('.attach_NOTIFY .qq-upload-list');
                break;
            case 'Deadline':
                uploader = $('.attach_DEADLINE .qq-upload-list');
                type = type.toUpperCase();
                break;
            case 'NoSchedule':
                uploader = $('.attach_NOSCHEDULE .qq-upload-list');
                type = type.toUpperCase();
                break;
            default:
                break;
        }
        if (fileCheck[type][file.EId]) {
            //checkbox is checked
            //Need to clear the list before you add the files
            $('.qq-upload-list').html('');
            angular.forEach($scope.defaultAttachments[type], function (value, idx) {
                //adding the checked file to the result object
                if ($scope.fileCheck[type][value.EId]) {
                    if ($scope.attachments[type]) {
                        $scope.attachments[type][value.EId] = {
                            resourceInfo: {
                                eid: value.EId,
                                fileName: value.fileName
                            }
                        };
                    } else {
                        $scope.attachments[value.EId] = {
                            resourceInfo: {
                                eid: value.EId,
                                fileName: value.fileName
                            }
                        };
                    }
                    //adding the checked file to the DOM
                    $compile(
                        uploader.append('<li class="qq-upload-success' + idx + '"><span class="qq-upload-file">' + value.fileName + '</span><span class="qq-upload-size" style="display:inline"></span><a ng-click="deleteDefaultAttachments(\'' + type + '\',\'' + idx + '\',\'' + value.EId + '\');" class="actn-delete" style="disply:inline-block">&nbsp;</a></li>')
                    )($scope);
                }


            });
        } else {
            $scope.deleteDefaultAttachments(type, index, file.EId);
        }
    };


    var showValidations = function () {
        //show all validations by expanding the message
        angular.forEach($scope.edit, function (key, interviewType) {
            $scope.edit[interviewType] = true;
        });

    };
    var validateContent = function (data) {
        for (var i in data) {
            if (!data[i].messageDataItem.content) {
                return false;
            }
        }
        return true;
    };

    $scope.handleSendCancellationNotification = function () {
        $scope.sendCancellationNotification = !$scope.sendCancellationNotification;
    };

    $scope.saveTemplate = function () {
        var isFormValid;
        if (!$.isEmptyObject($scope.attachments.SCHEDULE) || !$.isEmptyObject($scope.attachments.RESCHEDULE)) {
            $scope.result.attachments = {};
        }

        if (!$.isEmptyObject($scope.attachments.SCHEDULE)) {
            $scope.result.attachments.SCHEDULE = [];
            for (var atchmt in $scope.attachments.SCHEDULE) {
                if ($scope.attachments.SCHEDULE[atchmt].resourceInfo.eid) {
                    $scope.result.attachments.SCHEDULE.push($scope.attachments.SCHEDULE[atchmt].resourceInfo.eid);
                }
            }
        }

        if (!$.isEmptyObject($scope.attachments.RESCHEDULE)) {
            $scope.result.attachments.RESCHEDULE = [];
            for (var attach in $scope.attachments.RESCHEDULE) {
                if ($scope.attachments.RESCHEDULE[attach].resourceInfo.eid) {
                    $scope.result.attachments.RESCHEDULE.push($scope.attachments.RESCHEDULE[attach].resourceInfo.eid);
                }
            }
        }

        //Since select2 is giving us back an object . Extracting the eid out of the object
        if (Array.isArray($scope.result.cc)) {
            $scope.ccList = $scope.extract($scope.result.cc, 'EId');
        }
        if (!$.isEmptyObject($scope.result.bcc)) {
            $scope.bccList = $scope.extract($scope.result.bcc, 'EId');
        }
        if (!$.isEmptyObject($scope.result.to)) {
            $scope.toList = $scope.extract($scope.result.to, 'EId');
        }



        if (action === 'cancel') {
            var attachments = [];
            delete $scope.result.attachments;
            if ($scope.result.CANCEL) {
                if (!$scope.result.CANCEL.subject || !$scope.result.CANCEL.content) {
                    return;
                }
                angular.forEach($scope.result.CANCEL.attachments, function (value) {
                    attachments.push({
                        eid: value.resourceInfo.eid
                    });
                });
                $scope.result.CANCEL.attachments = attachments;
                if (!$scope.result.CANCEL_CANDIDATE_TEMPLATE) {
                    delete $scope.result.CANCEL.edit;
                }
            }
            if ($scope.result.CANCEL_NODATE) {
                if (!$scope.result.CANCEL_NODATE.subject || !$scope.result.CANCEL_NODATE.content) {
                    return;
                }
                attachments = [];
                angular.forEach($scope.result.CANCEL_NODATE.attachments, function (value) {
                    attachments.push({
                        eid: value.resourceInfo.eid
                    });
                });
                $scope.result.CANCEL_NODATE.attachments = attachments;
                delete $scope.result.CANCEL_NODATE.edit;
            }
            if ($scope.result.CANCEL_CANDIDATE_TEMPLATE) {
                if (!$scope.result.CANCEL_CANDIDATE_TEMPLATE.subject || !$scope.result.CANCEL_CANDIDATE_TEMPLATE.content) {
                    return;
                }
                var attachmentsCand = [];
                angular.forEach($scope.result.CANCEL_CANDIDATE_TEMPLATE.attachments, function (value) {
                    attachmentsCand.push({
                        eid: value.resourceInfo.eid
                    });
                });
                $scope.result.CANCEL_CANDIDATE_TEMPLATE.attachments = attachmentsCand;
                delete $scope.result.CANCEL_CANDIDATE_TEMPLATE.edit;
            }
            $scope.data = $scope.result;
        } else if (action !== 'schedule') {
            // invite flow
            /*Not allowing more than 150 Chars for subject field*/
            if (($scope.result.subject && $scope.result.subject.length > 150) || !$scope.result.content) {
                return;
            }
            delete $scope.result.SCHEDULE;
            delete $scope.attachments.SCHEDULE;
            angular.forEach($scope.result.attachments, function (value, key) {
                if (value === '') {
                    $scope.result.attachments.splice(key, 1);
                }
            });

            if (!$.isEmptyObject($scope.attachments['INVITE'])) {
                if (!$scope.result.attachments || $scope.result.attachments.length === 0) {
                    $scope.result.attachments = [];
                }
                for (var attch in $scope.attachments['INVITE']) {
                    if ($scope.attachments['INVITE'][attch].resourceInfo.eid) {
                        $scope.result.attachments.push($scope.attachments['INVITE'][attch].resourceInfo.eid);
                    }
                }
            }
            // Request modified to follow the common practice
            $scope.data = {
                messageDataItem: {
                    subject: $scope.result.subject,
                    content: $scope.result.content,
                    attachmentList: $scope.result.attachments || [],
                    bccList: $scope.bccList || [],
                    formIdList: $scope.result.formIds || []
                },
                candidateCopied: $scope.result.isCandidateCopied
            };
            
        } else if ($scope.interviewStatus === 'NoSchedule' || $scope.interviewStatus === 'Deadline') {
            //no schedule and deadline

            if ($scope.mode === 'modifySchedule' || $scope.mode === 'modifyMessage') {
                // Validating 'to' field,content
                if ($scope.emptyInterviewers || !validateContent($scope.postData.schedule)) {
                    return false;
                }
                isFormValid = processPostData($scope.postData.schedule);
                if (!isFormValid) {
                    showValidations();
                    return false;
                }
            } else {
                /*Not allowing more than 150 Chars for subject field*/
                if (($scope.result.subject && $scope.result.subject.length > 150) || !$scope.result.content) {
                    return;
                }

                //Validation for To field
                //locations disabled form the admin
                if ($scope.interviewStatus === 'NoSchedule') {
                    if (!$scope.result.noSchedule.to || $scope.result.noSchedule.to.length === 0) {
                        $scope.flags.loading = false;
                        $scope.toRequired = true;
                    } else {
                        $scope.toRequired = false;
                    }
                } else {
                    angular.forEach($scope.result.noLocations, function (value) {
                        if (!value.to || value.to.length === 0) {
                            $scope.flags.loading = false;
                            $scope.toRequired = true;
                        } else {
                            $scope.toRequired = false;
                        }
                        if ($scope.interviewStatus === 'Deadline' && (!value.fromDate || !value.toTime)) {
                            $scope.dateRequired = true;
                        } else {
                            $scope.dateRequired = false;
                        }
                    });
                }

                //validation
                if ($scope.toRequired || $scope.dateRequired) {
                    return;
                }
                $scope.data = $scope.createIntSchObj();
            }
        } else if ($scope.interviewStatus === 'Schedule') {
            // Validating 'to' field,content
            if ($scope.emptyInterviewers || !validateContent($scope.postData.schedule)) {
                return false;
            }
            isFormValid = processPostData($scope.postData.schedule);
            if (!isFormValid) {
                showValidations();
                return false;
            }
        }
        //Making sure we disable the send button so that users dont double click and end up creating duplicate interview schedules
        $scope.disableSchedule = true;
        $scope.flags.loading = true;

        for (var x in $scope.data) {
            if ((x === 'RESCHEDULE' || x === 'SCHEDULE' || x === 'NOTIFY' || x === 'MODIFY_MESSAGE') && $scope.data[x] && $scope.data[x].schedules && $scope.data[x].schedules.length > 0) {
                for (var i = 0; i < $scope.data[x].schedules.length; i++) {
                    for (var j = 0; j < $scope.data[x].schedules[i].interviewers.length; j++) {
                        if ($scope.data[x].schedules[i].interviewers[j].userEId === window.jvUser) {
                            $rootScope.fastRead.sameSchInterviewer = true;
                        }
                    }
                }
            }
        }
        /*
         * Wrppers used to split groupId and request.
         */
        if (action === 'schedule') {
            $scope.data = {
                scheduleRequest: $scope.data
            };
        } else if (action === 'cancel') {
            $scope.data = {
                cancelMessages: $scope.data,
                notifyCandidate: $scope.sendCancellationNotification
            };
        }
            
        /*
         * GroupId added to request incase of modify / invite / cancel
         */
        if ($scope.params.groupId) {
            $scope.data.groupId = $scope.params.groupId;
        }

        if ($scope.selectedTimezoneObj) {
            $scope.data.timezoneId = $scope.selectedTimezoneObj.id;
        }

        //Need to send invitation or updated message only to user's list in the to list. Let us remove the user's who are remvoed from the tolist
        if (isModifyMessageFlow()) {

            //changed scheduleRequest attribute from RESCHEDULE to NOTIFY for the action of notifyOnly.
            if (angular.isDefined($scope.data.scheduleRequest.RESCHEDULE)) {
                $scope.data.scheduleRequest.MODIFY_MESSAGE = $scope.data.scheduleRequest.RESCHEDULE;
                delete $scope.data.scheduleRequest['RESCHEDULE'];
            }
            angular.forEach($scope.updatedInterviewerList, function (updatedUser) {
                var updatedUserUserEId = updatedUser.userEId.split('+')[0];
                angular.forEach($scope.data.scheduleRequest.MODIFY_MESSAGE.schedules, function (schedule) {
                    angular.forEach(schedule.interviewers, function (interview) {
                        if (interview.interviewEId === updatedUser.interviewEId && interview.userEId === updatedUserUserEId) {
                            interview.sendInvite = true;
                        }
                    });
                });
            });
            //Let us remove the interviwers which are not marked as sendInvtie = true
            angular.forEach($scope.data.scheduleRequest.MODIFY_MESSAGE.schedules, function (schedule, key) {
                $scope.data.scheduleRequest.MODIFY_MESSAGE.schedules[key].interviewers = $filter('filter')($scope.data.scheduleRequest.MODIFY_MESSAGE.schedules[key].interviewers, {
                    'sendInvite': true
                });
            });
        }


        candidates.sendMessage($scope.data, $scope.templateParams, action, function (res, code) {
            if (code === 200) {
                $scope.flags.loading = false;
                $scope.resetScheduler();
                /*This getWorkflowSummary call is to avoid the replication lag so that the workflow summary page gets updated immediately after an interview has been scheduled/cancelled*/
                if ($scope.mode === 'schedule') {
                    //Is this the right place for new interview? Totango.
                    jvTotango.track('Create Interview', 'Recruiter');
                    $scope.showMsg($scope.interviewStatus);
                } else {
                    $scope.showMsg($scope.mode);
                }
                //Redirect to list page if user starts from list page
                $scope.$parent.selectedTimezoneObj = $scope.selectedTimezoneObj = null;
                var redirectToListPage = JSON.parse(window.localStorage.getItem('redirectToListAfterSchedule'));
                if (redirectToListPage) {
                    var CandidateListUrl = window.jvUrls.source + '/person/applicants.html?updateFetch=true';
                    $window.location.href = CandidateListUrl;
                } else {
                    $scope.getWorkflowSummary(0);
                    jvHireUrlService.loadCandidateDetailsTab('workflow', $routeParams.applicationId);
                }

            }
        });
    };

    $scope.createIntSchObj = function () {
        var postData = {},
            data = {};
        postData.schedules = [];

        if ($scope.result.locations) {
            angular.forEach($scope.result.locations, function (value) {
                var objs = {};
                objs.interviewers = [];
                if (value.to) {
                    angular.forEach(value.to, function (val) {
                        var intObj = {
                            userEId: val.EId
                        };
                        objs.interviewers.push(intObj);
                    });
                }
                objs.locationEId = value.location;
                objs.toDate = '';
                if (value.fromDate) {
                    var date = value.fromDate;
                    if (value.toTime) {
                        date.setHours(value.toTime.h);
                        date.setMinutes(value.toTime.m);
                    }
                    objs.fromDate = $rootScope.normalizeDates(date.getTime());
                } else {
                    objs.fromDate = '';
                }
                postData.schedules.push(objs);
            });

        } else {

            if ($scope.interviewStatus === 'NoSchedule') {
                var objs = {};
                objs.interviewers = [];
                if ($scope.result.noSchedule.to) {
                    angular.forEach($scope.result.noSchedule.to, function (val) {
                        var intObj = {
                            userEId: val.EId
                        };
                        objs.interviewers.push(intObj);
                    });
                }
                postData.schedules.push(objs);
            } else {
                angular.forEach($scope.result.noLocations, function (value) {
                    var objs = {};
                    objs.interviewers = [];
                    if (value.to) {
                        angular.forEach(value.to, function (val) {
                            var intObj = {
                                userEId: val.EId
                            };
                            objs.interviewers.push(intObj);
                        });
                    }
                    objs.toDate = '';
                    if (value.fromDate) {
                        var date = new Date(value.fromDate);
                        if (value.toTime) {
                            date.setHours(value.toTime.h);
                            date.setMinutes(value.toTime.m);
                        }
                        objs.fromDate = $rootScope.normalizeDates(date.getTime());
                    } else {
                        objs.fromDate = '';
                    }
                    postData.schedules.push(objs);
                });
            }
        }
        postData.messageDataItem = {};
        postData.messageDataItem.content = $scope.result.content;
        postData.messageDataItem.subject = $scope.result.subject;


        $scope.result.attachments = $scope.attachments;
        postData.messageDataItem.attachments = [];
        angular.forEach($scope.result.attachments[$scope.interviewStatus.toUpperCase()], function (value) {
            var objs2 = {};
            objs2.eid = value.resourceInfo.eid;
            postData.messageDataItem.attachments.push(objs2);
        });
        postData.messageDataItem.bcc = [];
        angular.forEach($scope.result.cc, function (value) {
            var objs3 = {};
            objs3.eid = value.EId;
            postData.messageDataItem.bcc.push(objs3);
        });
        //postData.messageDataItem.bcc = $scope.result.cc;

        postData.includePrevious = $scope.result.includePrevious;
        postData.forward = $scope.result.forward;

        data.SCHEDULE = postData;
        return data;
    };
    $scope.ismodifyModal = false;
    $scope.modifyModal = {
        show: false,
        buttons: [{
                label: i18n.EDIT_MESSAGE,
                title: i18n.EDIT_MESSAGE,
                click: function () {
                    $scope.$parent.modify = true;
                    $scope.modifyModal.show = false;
                    // passing 'true' in case of 'modify only message' flow
                    $scope.next(true);
                    $scope.ismodifyModal = false;

                }
            },
            {
                label: i18n.CANCEL,
                title: i18n.CANCEL,
                click: function () {
                    $scope.$parent.modify = false;
                    $scope.modifyModal.show = false;
                    $scope.ismodifyModal = false;
                },
                'class': 'cancel'
            }
        ],
        title: i18n.SCHEDNOCHANGES,
        body: i18n.SCHEDULE_NOCHANGES,
        context: $scope,
        cancel: function () {
            $scope.$parent.modify = false;
            $scope.modifyModal.show = false;
        }
    };

    $scope.updateInterviewers = function (interviewers) {
        $scope.updatedInterviewerList = interviewers;
        // validation for 'to' field
        if ($.isEmptyObject($scope.updatedInterviewerList)) {
            $scope.emptyInterviewers = true;
        } else {
            $scope.emptyInterviewers = false;
        }
    };

    //ui-select2 input
    var getInterviewerInfo = function (interviews) {
        var interviewerObj = [],
            timestamp;
        angular.forEach(interviews, function (interview) {
            timestamp = $filter('localeDateTime')(interview.scheduleUtc, 'longTimestamp', 'MMMM dd, yyyy HH:mm:ss');
            timestamp = new Date(timestamp).getTime();
            angular.forEach(interview.interviewers, function (interviewer) {
                interviewer.timestamp = timestamp;
                interviewer.userEId = interviewer.userEId + '+' + timestamp;
                interviewerObj.push(interviewer);
            });
        });
        return interviewerObj;
    };

    // config for ui-select2's input with static object.
    $scope.select2Options = {
        id: 'userEId',
        multiple: true,
        data: {
            results: {},
            text: 'firstName'
        },
        formatResult: function (employee) {
            return '<strong>' + employee.firstName + ' ' + employee.lastName + '</strong>' + employee.email;
        },
        formatSelection: function (employee) {
            return employee.firstName + ' ' + employee.lastName;
        },
        escapeMarkup: function (m) {
            return m;
        },
        initSelection: function (element, callback) {
            var interviewers = getInterviewerInfo($scope.interviewSchedule.data.durationInfo);
            interviewers = $filter('orderBy')(interviewers, 'firstName');
            interviewers = $filter('orderBy')(interviewers, 'timestamp');
            $scope.select2Options.data.results = interviewers;
            callback(interviewers);
        }
    };
}
